import { singleApiReducer } from './single-api-reducer';
import API from '../../API';

export const useLooseOrder = singleApiReducer((id: number) => API.looseOrder(id).get());
